import { useThrottledCallback } from "@mantine/hooks";
import IconLayoutSidebarLeftCollapse from "@src/assets/icons/tabler/layout-sidebar-left-collapse.svg?react";
import IconLayoutSidebarLeftExpand from "@src/assets/icons/tabler/layout-sidebar-left-expand.svg?react";
import { useMenuState } from "@src/components/layouts/menu/menu-drawer";
import clsx from "clsx";

export function NavigationToggleButton() {
	const { isDrawerOpen, toggleDrawer, isDesktop } = useMenuState();

	const handlePointerDown = useThrottledCallback(toggleDrawer, 100);
	const width = isDesktop ? 30 : 42;
	const height = isDesktop ? 30 : 42;

	return (
		<button
			type="button"
			onPointerDown={handlePointerDown}
			title={isDrawerOpen ? "Close navbar" : "Open navbar"}
			aria-label={isDrawerOpen ? "Close navbar" : "Open navbar"}
			className={clsx(
				"flex items-center justify-center leading-none rounded-md",
				"border border-transparent bg-surface-subtle",
				"text-text-secondary hover:bg-surface-hover-subtle",
				"hover:text-text-primary hover:border-border-subtle",
				"cursor-pointer",
				isDesktop ? "h-7.5 w-7.5" : "h-10.5 w-10.5",
			)}
		>
			{isDrawerOpen ? (
				<IconLayoutSidebarLeftCollapse
					width={width}
					height={height}
					strokeWidth={1}
				/>
			) : (
				<IconLayoutSidebarLeftExpand
					width={width}
					height={height}
					strokeWidth={1}
				/>
			)}
		</button>
	);
}
